export default __webpack_public_path__ + "static/1004-20184e347783f4d23d533e220da5c5c7.gif";